// 데모 모드 컨텍스트
// 플레이 스토어 검수용 — 서버 없이 샘플 데이터로 앱을 체험할 수 있게 해 주는 전역 상태

import React, { createContext, useCallback, useContext, useState } from "react"
import { BedSlot } from "@modules/android/link/treatmentRoom/TreatmentRoom.types"
import { VisitListSerializer } from "@/types/visit"
import { clearStoredAuthState, DEMO_AUTH_TOKEN_KEY, DEMO_MODE_KEY } from "@core/utils/webSessionAuth"

// ── 데모용 상수 ──
const DEMO_TOKEN = "demo-token-for-playstore-review"
const DEMO_MEMBER_NAME = "데모사용자"
const DEMO_HOSPITAL_NAME = "시그마한의원(데모)"
const NO_CHART_MODE_KEY = "sigmaNoChartMode"
export const NO_CHART_HOSPITAL_NAME_KEY = "sigmaNoChartHospitalName"

// ── 데모 치료실 베드 데이터 ──
const now = new Date()
const minutesAgo = (m: number) => new Date(now.getTime() - m * 60000).toISOString()

export const DEMO_BED_SLOTS: BedSlot[] = [
  {
    bedNumber: "1",
    patientName: "김민수",
    patientId: "10001",
    patientUuid: "demo-uuid-1",
    startedAt: minutesAgo(25),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "done", startedAt: minutesAgo(25) },
      { itemId: "ict", state: "active", startedAt: minutesAgo(12) },
      { itemId: "cupping", state: "none" },
      { itemId: "acupuncture", state: "none" },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "2",
    patientName: "이영희",
    patientId: "10002",
    patientUuid: "demo-uuid-2",
    startedAt: minutesAgo(40),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "done", startedAt: minutesAgo(40) },
      { itemId: "ict", state: "done", startedAt: minutesAgo(30) },
      { itemId: "cupping", state: "done", startedAt: minutesAgo(20) },
      { itemId: "acupuncture", state: "active", startedAt: minutesAgo(10) },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "3",
    patientName: "박지훈",
    patientId: "10003",
    patientUuid: "demo-uuid-3",
    startedAt: minutesAgo(15),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "active", startedAt: minutesAgo(15) },
      { itemId: "ict", state: "none" },
      { itemId: "cupping", state: "none" },
      { itemId: "acupuncture", state: "none" },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "4",
    patientName: "최수연",
    patientId: "10004",
    patientUuid: "demo-uuid-4",
    startedAt: minutesAgo(55),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "done", startedAt: minutesAgo(55) },
      { itemId: "ict", state: "done", startedAt: minutesAgo(45) },
      { itemId: "cupping", state: "done", startedAt: minutesAgo(35) },
      { itemId: "acupuncture", state: "done", startedAt: minutesAgo(25) },
      { itemId: "hydrotherapy", state: "done", startedAt: minutesAgo(15) },
      { itemId: "moxa", state: "active", startedAt: minutesAgo(5) },
    ],
  },
  {
    bedNumber: "5",
    patientName: "정다은",
    patientId: "10005",
    patientUuid: "demo-uuid-5",
    startedAt: minutesAgo(35),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "done", startedAt: minutesAgo(35) },
      { itemId: "ict", state: "done", startedAt: minutesAgo(25) },
      { itemId: "cupping", state: "active", startedAt: minutesAgo(15) },
      { itemId: "acupuncture", state: "none" },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "6",
    patientName: "한상우",
    patientId: "10006",
    patientUuid: "demo-uuid-6",
    startedAt: minutesAgo(50),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "done", startedAt: minutesAgo(50) },
      { itemId: "ict", state: "done", startedAt: minutesAgo(40) },
      { itemId: "cupping", state: "done", startedAt: minutesAgo(30) },
      { itemId: "acupuncture", state: "active", startedAt: minutesAgo(18) },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "7",
    patientName: "오지영",
    patientId: "10007",
    patientUuid: "demo-uuid-7",
    startedAt: minutesAgo(20),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "done", startedAt: minutesAgo(20) },
      { itemId: "ict", state: "active", startedAt: minutesAgo(8) },
      { itemId: "cupping", state: "none" },
      { itemId: "acupuncture", state: "none" },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "8",
    patientName: "",
    patientId: "",
    isEmpty: true,
    items: [],
  },
  {
    bedNumber: "9",
    patientName: "송윤아",
    patientId: "10008",
    patientUuid: "demo-uuid-8",
    startedAt: minutesAgo(10),
    isEmpty: false,
    items: [
      { itemId: "hotpack", state: "active", startedAt: minutesAgo(10) },
      { itemId: "ict", state: "none" },
      { itemId: "cupping", state: "none" },
      { itemId: "acupuncture", state: "none" },
      { itemId: "hydrotherapy", state: "none" },
      { itemId: "moxa", state: "none" },
    ],
  },
  {
    bedNumber: "10",
    patientName: "",
    patientId: "",
    isEmpty: true,
    items: [],
  },
]

// ── 데모 동의서 환자 데이터 ──
const makeDemoVisit = (overrides: Partial<VisitListSerializer>): VisitListSerializer =>
  ({
    visitId: 0,
    visitUuid: "",
    patientId: 0,
    patientUuid: "",
    patientName: "",
    patientBirth: "1990-01-01",
    patientAge: 36,
    patientGender: "M",
    patientIdentity: "",
    visitMemo: "",
    visitStatus: "waiting",
    visitStatusUpdatedDt: now.toISOString(),
    visitCompleteDt: "",
    createdDt: now.toISOString(),
    insuranceId: 0,
    ...overrides,
  }) as VisitListSerializer

export const DEMO_WAITING_PATIENTS: VisitListSerializer[] = [
  makeDemoVisit({
    visitId: 1,
    visitUuid: "demo-v1",
    patientId: 10001,
    patientUuid: "demo-uuid-1",
    patientName: "김민수",
    patientAge: 45,
    patientGender: "M",
    visitStatus: "waiting",
  }),
  makeDemoVisit({
    visitId: 2,
    visitUuid: "demo-v2",
    patientId: 10005,
    patientUuid: "demo-uuid-5",
    patientName: "정다은",
    patientAge: 32,
    patientGender: "F",
    visitStatus: "waiting",
    visitMemo: "허리 통증",
  }),
  makeDemoVisit({
    visitId: 9,
    visitUuid: "demo-v9",
    patientId: 10009,
    patientUuid: "demo-uuid-9",
    patientName: "임서연",
    patientAge: 29,
    patientGender: "F",
    visitStatus: "waiting",
    visitMemo: "무릎 통증",
  }),
]

export const DEMO_TREATMENT_PATIENTS: VisitListSerializer[] = [
  makeDemoVisit({
    visitId: 3,
    visitUuid: "demo-v3",
    patientId: 10002,
    patientUuid: "demo-uuid-2",
    patientName: "이영희",
    patientAge: 58,
    patientGender: "F",
    visitStatus: "treatment",
    visitMemo: "경추 디스크",
  }),
  makeDemoVisit({
    visitId: 4,
    visitUuid: "demo-v4",
    patientId: 10003,
    patientUuid: "demo-uuid-3",
    patientName: "박지훈",
    patientAge: 27,
    patientGender: "M",
    visitStatus: "treatment",
    visitMemo: "어깨 통증",
  }),
  makeDemoVisit({
    visitId: 5,
    visitUuid: "demo-v5",
    patientId: 10004,
    patientUuid: "demo-uuid-4",
    patientName: "최수연",
    patientAge: 41,
    patientGender: "F",
    visitStatus: "treatment",
    visitMemo: "목 디스크",
  }),
  makeDemoVisit({
    visitId: 7,
    visitUuid: "demo-v7",
    patientId: 10007,
    patientUuid: "demo-uuid-7",
    patientName: "오지영",
    patientAge: 35,
    patientGender: "M",
    visitStatus: "treatment",
    visitMemo: "요통",
  }),
  makeDemoVisit({
    visitId: 10,
    visitUuid: "demo-v10",
    patientId: 10008,
    patientUuid: "demo-uuid-8",
    patientName: "송윤아",
    patientAge: 52,
    patientGender: "F",
    visitStatus: "treatment",
    visitMemo: "손목 터널증후군",
  }),
]

export const DEMO_COMPLETE_PATIENTS: VisitListSerializer[] = [
  makeDemoVisit({
    visitId: 6,
    visitUuid: "demo-v6",
    patientId: 10006,
    patientUuid: "demo-uuid-6",
    patientName: "한상우",
    patientAge: 63,
    patientGender: "M",
    visitStatus: "complete",
    visitMemo: "요추 협착증",
  }),
  makeDemoVisit({
    visitId: 8,
    visitUuid: "demo-v8",
    patientId: 10010,
    patientUuid: "demo-uuid-10",
    patientName: "김정호",
    patientAge: 48,
    patientGender: "M",
    visitStatus: "complete",
    visitMemo: "오십견",
  }),
  makeDemoVisit({
    visitId: 11,
    visitUuid: "demo-v11",
    patientId: 10011,
    patientUuid: "demo-uuid-11",
    patientName: "이지은",
    patientAge: 37,
    patientGender: "F",
    visitStatus: "complete",
  }),
]

// ── 컨텍스트 ──
interface DemoModeContextValue {
  isDemoMode: boolean
  isNoChartMode: boolean
  enterDemoMode: () => void
  enterNoChartMode: (hospitalName: string) => void
  exitDemoMode: () => void
  demoMemberName: string
  demoHospitalName: string
}

const DemoModeContext = createContext<DemoModeContextValue>({
  isDemoMode: false,
  isNoChartMode: false,
  enterDemoMode: () => {},
  enterNoChartMode: () => {},
  exitDemoMode: () => {},
  demoMemberName: DEMO_MEMBER_NAME,
  demoHospitalName: DEMO_HOSPITAL_NAME,
})

export const useDemoMode = () => useContext(DemoModeContext)

export const DemoModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState(() => localStorage.getItem(DEMO_MODE_KEY) === "true")
  const [isNoChartMode, setIsNoChartMode] = useState(() => localStorage.getItem(NO_CHART_MODE_KEY) === "true")
  const noChartHospitalName = localStorage.getItem(NO_CHART_HOSPITAL_NAME_KEY) || "의료기관이름"

  const enterDemoMode = useCallback(() => {
    // 데모 전용 인증 상태 설정
    clearStoredAuthState()
    localStorage.setItem(DEMO_AUTH_TOKEN_KEY, DEMO_TOKEN)
    localStorage.setItem(DEMO_MODE_KEY, "true")
    localStorage.removeItem(NO_CHART_MODE_KEY)
    setIsDemoMode(true)
    setIsNoChartMode(false)
  }, [])

  const enterNoChartMode = useCallback((hospitalName: string) => {
    // 서버 연동 없이 동의서 화면을 사용하기 위해 데모 인증 흐름을 재사용한다.
    clearStoredAuthState()
    localStorage.setItem(DEMO_AUTH_TOKEN_KEY, DEMO_TOKEN)
    localStorage.setItem(DEMO_MODE_KEY, "true")
    localStorage.setItem(NO_CHART_MODE_KEY, "true")
    localStorage.setItem(NO_CHART_HOSPITAL_NAME_KEY, hospitalName)
    setIsDemoMode(true)
    setIsNoChartMode(true)
  }, [])

  const exitDemoMode = useCallback(() => {
    clearStoredAuthState()
    localStorage.removeItem(DEMO_MODE_KEY)
    localStorage.removeItem(NO_CHART_MODE_KEY)
    // NO_CHART_HOSPITAL_NAME_KEY는 유지 — PIN과 동일하게 반영구 설정
    setIsDemoMode(false)
    setIsNoChartMode(false)
  }, [])

  return (
    <DemoModeContext.Provider
      value={{
        isDemoMode,
        isNoChartMode,
        enterDemoMode,
        enterNoChartMode,
        exitDemoMode,
        demoMemberName: isNoChartMode ? noChartHospitalName : DEMO_MEMBER_NAME,
        demoHospitalName: DEMO_HOSPITAL_NAME,
      }}
    >
      {children}
    </DemoModeContext.Provider>
  )
}

